import { render, staticRenderFns } from "./PaginationCompareBtn.vue?vue&type=template&id=4d4c1726&scoped=true&"
import script from "./PaginationCompareBtn.vue?vue&type=script&lang=js&"
export * from "./PaginationCompareBtn.vue?vue&type=script&lang=js&"
import style0 from "./PaginationCompareBtn.vue?vue&type=style&index=0&id=4d4c1726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c1726",
  null
  
)

export default component.exports